module.exports = __webpack_public_path__ + "static/media/courier-flow.1300d972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/purchase/state-info/courier-flow.png
// module id = 1789
// module chunks = 0